// TotalInventory Mutations

export const updateTotalInventoryList = (state, payload) => {
  state.totalInventoryList = payload
}

export const fetchTotalInventoryInfo = (state, payload) => {
  state.totalInventoryInfo = payload
}

export const fetchInventoryInfo = (state, payload) => {
  state.inventoryInfo = payload
}
